import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../baseContainers/BaseDetailsContainer';
import DivContainer from '../components/DivContainer';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import InternalUserService from '../services/InternalUserService';
import YesNoDialog from '../components/YesNoDialog';
import {t} from 'i18next';
import InputMultiSelectComponent from '../components/inputs/InputMultiSelectComponent';
import UserRoleService from '../services/UserRoleService';
import { TabPanel, TabView } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import moment from 'moment';
import Constants from '../utils/constants';
import ActionLink from '../components/ActionLink';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import InputNumberComponent from '../components/inputs/InputNumberComponent';
import LogEntryListContainer from './LogEntryListContainer';
import { withRouter } from "react-router-dom";

class InternalUserContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new InternalUserService());
        this.userRoleService = new UserRoleService();
        this.contractDayMode = {
            view: 'month',
            dateFormat: 'mm-yy',
            placeholder: 'mm-yy',
            dateFormatMoment: 'MM-YYYY',
            yearNavigator: true,
        };
        this.state = {
            dialogVisibile: false,
            showConfirmBlockDialog: false,
            showConfirmUnblockDialog: false,
            elementId: this.props.elementId,
            element: {
                firstName: '',
                lastName: '',
                email: '',
                roles: undefined,
                status: {enumValue: 'ACTIVE', enumLabel: 'Aktywny'},
                subcontractor: undefined,
                contracts: []
            },
            editElement: null,
            loading: true,
            size: 0,
            first: 0,
            statusOptions: [],
            roleOptions: [],
            viewMode: props.viewMode
        };
        this.handleGoToDetail = this.handleGoToDetail.bind(this);
        this.prepareFooter = this.prepareFooter.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.setEditViewMode = this.setEditViewMode.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.blockAccount = this.blockAccount.bind(this);
        this.unblockAccount = this.unblockAccount.bind(this);
        this.showBlockConfirmation = this.showBlockConfirmation.bind(this);
        this.hideBlockConfirmation = this.hideBlockConfirmation.bind(this);
        this.showUnblockConfirmation = this.showUnblockConfirmation.bind(this);
        this.hideUnblockConfirmation = this.hideUnblockConfirmation.bind(this);
        this.prepareSaveAndCancelButton=this.prepareSaveAndCancelButton.bind(this);
        this.handleCancel = this.handleCancel.bind(this);


        this.setContractsDatesTo = this.setContractsDatesTo.bind(this)
        this.calculateMinDateForDateFrom = this.calculateMinDateForDateFrom.bind(this)
        this.calculateMinDateForDateTo = this.calculateMinDateForDateTo.bind(this)
        this.calculateMaxDateForDateFrom = this.calculateMaxDateForDateFrom.bind(this)



        this.validator.addCustomRule('contract_no_duplicates', t('employee.details.vaidation_contract_no_duplicates'), (value) => {
            const dates = value.map((c) => moment(c.dateFrom).format('yyyy-MM-DD'));
            const findDuplicatesFunction = (arry) => arry.filter((item, index) => dates.indexOf(item) !== index);
            const duplicates = findDuplicatesFunction(dates);
            return duplicates.length == 0;
        });

        this.validator.addCustomRule('no_overlapping_dates', t('employee.absence.validation.no_overlapping_dates'), (value) => {
            let flag = true;
            value.forEach((x, indexX) => {
                value.forEach((y, indexY) => {

                    if (indexX !== indexY) {
                        const startDateY = moment(y.dateFrom);
                        const endDateY = moment(y.dateTo);
                        const startDateX = moment(x.dateFrom);
                        const endDateX = moment(x.dateTo);

                        if (
                            startDateX.isBetween(startDateY, endDateY) ||
                            endDateX.isBetween(startDateY, endDateY) ||
                            endDateX.isSame(endDateY) && startDateX.isSame(startDateY) ||
                            endDateX.isSame(startDateY) || startDateX.isSame(endDateY)
                        ) {
                            flag = false;
                        }
                    }
                });
            });
            return flag;
        })

        this.validator.addCustomRule('date_from_less_than_date_to', 'Data od nie moze być po dacie powrotu', (value,index) => {
                const absence = this.state.element.absences[index];
                const dateTo = absence.dateTo;
                return moment(value).isSameOrBefore(moment(dateTo));
            }   ,
            (message, params) => message.replace(':date', params[0])
        )

         this.validator.addCustomRule('date_to_must_be_bigger_than_date_from', 'Data powrotu nie moze być przed datą od',
            (value,index) => {
                const absence = this.state.element.absences[index];
                const dateFrom = absence.dateFrom;
                return moment(value).isSameOrAfter(moment(dateFrom));
            },
            (message, params) => message.replace(':date', params[0])
        )
        this.validator.addCustomRule('contract_must_be_defined', 'Pracownik musi posiadać przynajmniej jeden kontrakt',
        (value) => {
            return value.length>0;
        })

    }
    sortContracts(contracts) {
        contracts.sort((c1, c2) => (c1.dateFrom < c2.dateFrom ? 1 : -1));
    }

    updateElement(data) {
        if(data.contracts){
            data.contracts.forEach((contract) => {
                if (contract.dateFrom) {
                    contract.dateFrom = new Date(contract.dateFrom)
                }
                if (contract.dateTo) {
                    contract.dateTo = new Date(contract.dateTo)
                }
            })
            this.sortContracts(data.contracts);
        }
        this.setState(
            {
                element: {
                    id: data.id,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    email: data.email,
                    roles: data.roles,
                    status: data.status,
                    subcontractor: data.subcontractor,
                    contracts: data.contracts
                },
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }


    contractPriceTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id={`contractPrice${rowIndex}`}
                name='value'
                label={t('employee.details.price')}
                value={rowData.price.value}
                stateField={`element.contracts[${rowIndex}].price`}
                showLabel={false}
                onChange={this.handleChange}
                insideTable
                viewMode={this.state.viewMode}
                validator={this.validator}
                validators='required'
                mode='currency'
                currency='PLN'
                locale='pl-PL'
            />
        );
    }


    initBeforeSetElement() {
        this.enumService
            .getEnumList('UserActivityStatus')
            .then((statusOptions) =>
                this.setState({
                    statusOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
        this.userRoleService
            .getAllForOfficeWorker()
            .then(roleOptions => {
                this.setState({ roleOptions });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy ról');
            });

        this.enumService
            .getEnumList('UserContractType')
            .then((contractTypes) => this.setState({ contractTypes }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy typów kontraktu');
            });
    }


    prepareFooterItems() {
        const result = this.prepareSaveAndCancelButton();
        if (this.authService.isUserInAnyRole('ROLE_USER_EDIT') && this.props.viewMode === 'VIEW') {
            if (this.state.viewMode === 'VIEW') {
                result.push({ label: 'Edytuj', className: 'float-right', onClick: this.setEditViewMode.bind(this) });
            }

            if (this.state.element.status.enumValue === 'ACTIVE'
                && this.state.viewMode === 'VIEW'
            ) {
                result.push({ label: t('internaluser.blockButton'), className: 'fullred float-right', onClick: this.showBlockConfirmation });
            } else {
                if (this.state.viewMode === 'VIEW') {
                    result.push({
                        label: t('internaluser.unblockButton'),
                        className: 'fullred float-right',
                        onClick: this.showUnblockConfirmation,
                    });
                }
            }
        }
        return result;
    }

    prepareSaveAndCancelButton(){
        const {viewMode} = this.state;

        switch (viewMode) {
            case 'EDIT':
            case 'NEW':
                return [
                    {label: 'Anuluj', className: 'cancel-button white', onClick: this.handleCancel},
                    {label: 'Zapisz', className: 'float-right', onClick: this.handleFormSubmit},
                ];
            case 'VIEW':
            default:
                return [];
        }
    }
    handleGoBack() {
        this.blockUi();
        const {backUrl} = this.props;
        window.location.href = backUrl;
    }

    handleCancel() {
        const { viewMode } = this.state;
        if (viewMode === 'NEW') {
            this.handleGoBack()
        } else {
            this.setState({
                viewMode: 'VIEW'
            }, this.setElement());
        }
    }

    setEditViewMode(e) {
        this.setState({ viewMode: 'EDIT' });
    }

    showBlockConfirmation() {
        this.setState({showConfirmBlockDialog: true});
    }

    hideBlockConfirmation() {
        this.setState({showConfirmBlockDialog: false});
    }

    showUnblockConfirmation() {
        this.setState({showConfirmUnblockDialog: true});
    }

    hideUnblockConfirmation() {
        this.setState({showConfirmUnblockDialog: false});
    }

    blockAccount() {
        this.blockUi();
        this.service
            .blockAccount(this.state.element.id)
            .then((result) => {
                this.showSuccessMessage(t('internaluser.messages.accountBlockedSuccess'));
                this.updateElement(result);
                this.hideBlockConfirmation();
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.hideBlockConfirmation();
                this.unblockUi();
            });
    }

    unblockAccount() {
        this.blockUi();
        this.service
            .unblockAccount(this.state.element.id)
            .then((result) => {
                this.showSuccessMessage(t('internaluser.messages.accountUnblockedSuccess'));
                this.updateElement(result);
                this.hideUnblockConfirmation();
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage(err.messages);
                this.hideUnblockConfirmation();
                this.unblockUi();
            });
    }

    isPdfButtonRendered() {
        return false;
    }

    contractCostTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        return (
            <InputNumberComponent
                id={`contractCost${rowIndex}`}
                name='value'
                label={t('employee.details.cost')}
                value={rowData.cost.value}
                stateField={`element.contracts[${rowIndex}].cost`}
                showLabel={false}
                onChange={this.handleChange}
                insideTable
                viewMode={this.state.viewMode}
                validator={this.validator}
                validators='required'
                mode='currency'
                currency='PLN'
                locale='pl-PL'
            />
        );
    }
    contractTypeTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const canEdit = this.authService.isUserInRole('ROLE_USER_EDIT') && this.isUserInRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <div style={{ minWidth: '150px', maxWidth: '200px' }}>
                <InputDropdownComponent
                    id={`contractType${rowIndex}`}
                    name='contractType'
                    label={t('employee.details.contractType')}
                    value={rowData.contractType}
                    stateField={`element.contracts[${rowIndex}]`}
                    showLabel={false}
                    options={this.state.contractTypes}
                    optionLabel='label'
                    dataKey='enumValue'
                    onChange={this.handleChange}
                    insideTable
                    viewMode={canEdit ? this.state.viewMode : 'VIEW'}
                    validator={this.validator}
                    validators='required'
                    colClass='p-2'
                />
            </div>
        );
    }



    calculateMinDateForDateFrom(rowIndex) {
        const contracts = this.state.element?.contracts;
        if (contracts.length > 0) {
            const currentContract = contracts[rowIndex];
            const prevContract = contracts[rowIndex + 1];
            if (prevContract?.dateTo) {
                return moment(prevContract.dateFrom).clone().add(1, 'months').toDate();
            } else {
                return moment(currentContract.dateFrom).toDate();
            }
        }
        return null;
    }
    calculateMaxDateForDateFrom(rowIndex) {
        const contracts = this.state.element?.contracts;
        if (contracts.length > 0) {
            const currentContract = contracts[rowIndex];
            if (currentContract.dateTo) return moment(currentContract.dateTo).toDate();
        }
        return null;
    }

    calculateMinDateForDateTo(rowIndex) {
        const contracts = this.state.element?.contracts;
        if (contracts.length > 0) {
            const currentContract = contracts[rowIndex];
            if (currentContract.dateFrom) {
                return moment(currentContract.dateFrom).toDate();
            }
        }
        return null;
    }

    setContractsDatesTo() {
        const contracts = this.state.element.contracts;
        contracts.forEach((c) => {
            c.dateTo = null;
            const dates = contracts.map((c2) => c2.dateFrom).filter((d) => d > c.dateFrom);
            if (dates.length > 0) {
                const minDate = new Date(Math.min(...dates.map((date) => date.getTime())));
                c.dateTo = moment(minDate).subtract(1, this.contractDayMode.view).toDate();
            }
        });
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                contracts: contracts,
            },
        }));
    }



    contractDateFromTemplate(rowData, column) {
        const rowIndex = column.rowIndex;
        const dateFrom = rowData.dateFrom;
        const disabled = (moment(dateFrom).isSameOrBefore(moment(), this.contractDayMode.view) && rowData.id);
        const canEdit = this.authService.isUserInAnyRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <div style={{ minWidth: '120px', maxWidth: '200px' }}>
                <InputCalendarComponent
                    id={`contractDateFrom${rowIndex}`}
                    name='dateFrom'
                    value={rowData.dateFrom}
                    stateField={`element.contracts[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    viewMode={canEdit ? this.state.viewMode : 'VIEW'}
                    validator={this.validator}
                    validators='required'
                    disabled={disabled}
                    minDate={(disabled || this.state.element?.contracts.length === 1)
                    ? null : this.calculateMinDateForDateFrom(rowIndex)}
                    maxDate={this.calculateMaxDateForDateFrom(rowIndex)}
                    showClear
                    onAfterStateChange={() => {
                        this.setContractsDatesTo();
                    }}
                    dateFormatMoment={this.contractDayMode.dateFormatMoment}
                    view={this.contractDayMode.view}
                    dateFormat={this.contractDayMode.dateFormat}
                    placeholder={this.contractDayMode.placeholder}
                    yearNavigator={this.contractDayMode.yearNavigator}
                    showIcon
                />
            </div>
        );
    }

    contractDateToTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const canEdit = this.authService.isUserInAnyRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <div style={{ minWidth: '120px', maxWidth: '180px' }}>
                <InputCalendarComponent
                    id={`contractDateTo${rowIndex}`}
                    name='dateTo'
                    value={rowData.dateTo}
                    stateField={`element.contracts[${rowIndex}]`}
                    showLabel={false}
                    onChange={this.handleChange}
                    insideTable
                    minDate={this.calculateMinDateForDateTo(rowIndex)}
                    viewMode={canEdit ? this.state.viewMode : 'VIEW'}
                    validator={this.validator}
                    validators='not_required'
                    disabled
                    dateFormatMoment={this.contractDayMode.dateFormatMoment}
                    view={this.contractDayMode.view}
                    dateFormat={this.contractDayMode.dateFormat}
                    placeholder={this.contractDayMode.placeholder}
                    yearNavigator={this.contractDayMode.yearNavigator}
                    showIcon
                />
            </div>
        );
    }


    contractsActionsTemplate(rowData, props) {
        const rowIndex = props.rowIndex;
        const dateFrom = rowData.dateFrom;
        const disabled = moment(dateFrom).isSameOrBefore(moment(), this.contractDayMode.view) && rowData.id;
        return (
            <span>
                <ActionLink
                    iconName='mdi-delete'
                    iconSide='left'
                    iconSize='icon-large'
                    handleClick={(e) => {
                        let contracts = this.state.element.contracts.filter((c) => c !== rowData);
                        this.setState(
                            (prevState) => ({
                                element: {
                                    ...prevState.element,
                                    contracts,
                                },
                            }),
                            () => this.setContractsDatesTo(rowIndex)
                        );
                    }}
                    variant='blue'
                    className='edit-blue-link'
                    key={'delete-button'}
                    disabled={disabled}
                />
            </span>
        );
    }

    canAddNewContract() {
        if ((this.state.viewMode === 'NEW' && this.state.element?.contracts?.length === 0) || this.state.viewMode === 'EDIT') {
            return true;
        }
        return false;
    }

    createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key]) ? queryObject[key].map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&') : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            }).join('&');
        return queryString ? `?${queryString}` : "";
    };

    renderDetails() {
        const canViewPrices = this.authService.isUserInAnyRole('ROLE_USER_CONTRACT_ACCESS');
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='col-12'>
                        <div className='row profile'>
                            <InputTextComponent
                                id='firstName'
                                name='firstName'
                                label={t('internaluser.details.firstName')}
                                colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                value={this.state.element.firstName}
                                validator={this.validator}
                                validators='required|alpha|max:100'
                                onChange={this.handleChange}
                                viewMode={this.state.viewMode}
                            />

                            <InputTextComponent
                                id='lastName'
                                name='lastName'
                                label={t('internaluser.details.lastName')}
                                colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                value={this.state.element.lastName}
                                validator={this.validator}
                                validators='required|alpha|max:100'
                                onChange={this.handleChange}
                                viewMode={this.state.viewMode}
                            />
                        </div>
                        <div className='row profile'>
                            <InputTextComponent
                                id='email'
                                name='email'
                                label={t('internaluser.details.email')}
                                colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                value={this.state.element.email}
                                validator={this.validator}
                                validators='required|email|max:100'
                                onChange={this.handleChange}
                                viewMode={this.state.viewMode}
                            />
                            <InputMultiSelectComponent
                                id='roles'
                                name='roles'
                                label={t('internaluser.details.role')}
                                colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                value={this.state.element.roles}
                                validator={this.validator}
                                options={this.state.roleOptions}
                                onChange={this.handleChange}
                                viewMode={this.state.viewMode}
                                dataKey='id' 
                                validators='required'
                                optionLabel='name'
                            />
                        </div>
                        <div className='row profile'>
                            <InputDropdownComponent
                                id='subcontractor'
                                name='subcontractor'
                                label={t('internaluser.details.subcontractorName')}
                                colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                value={this.state.element.subcontractor}
                                validator={this.validator}
                                options={this.state.subcontractors}
                                onChange={this.handleChange}
                                viewMode={this.state.viewMode}
                                dataKey='id'
                                filter={true}
                                showClear={true}
                                validators='not_required'
                                optionLabel='name'
                                valueView={this.state.element?.subcontractor?.name}
                            />
                            {this.state.viewMode !== 'NEW' ? (
                                <InputDropdownComponent
                                    id='status'
                                    name='status'
                                    label={t('internaluser.details.status')}
                                    colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                    value={this.state.element.status}
                                    validator={this.validator}
                                    options={this.state.statusOptions}
                                    onChange={null}
                                    viewMode={this.state.viewMode === 'EDIT' ? 'VIEW' : this.state.viewMode}
                                    optionLabel='label'
                                    dataKey='enumValue'
                                    validators='not_required'
                                    rendered={this.state.viewMode !== 'NEW'}
                                    valueView={this.state.element.status ? this.state.element.status.label : ''}
                                />
                            ) : null}
                        </div>
                    </DivContainer>
                    <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => {
                        this.setState({ activeIndex: e.index }, () => {
                            this.props.history.push({
                                search: this.createQueryString({ activeIndex: e.index })
                            });
                        });
                    }} >
                        <TabPanel header={'Kontrakty'}>
                            <div className='row profile'>
                                <Card header='Kontrakty' style={{ marginTop: '50px' }}>
                                    <DivContainer colClass='col-12'>
                                        <DataTable id='contracts' value={this.state.element.contracts} responsiveLayout='scroll' emptyMessage={t('list.empty')}>
                                            <Column
                                                field='dateFrom'
                                                header={t('employee.details.dateFrom')}
                                                body={this.contractDateFromTemplate.bind(this)}
                                            ></Column>
                                            <Column
                                                field='dateTo'
                                                header={t('employee.details.dateTo')}
                                                body={this.contractDateToTemplate.bind(this)}
                                            ></Column>

                                            <Column
                                                field='contractType'
                                                header={t('employee.details.contractType')}
                                                body={this.contractTypeTemplate.bind(this)}
                                            ></Column>
                                            {canViewPrices && this.authService.getProfile().userContractPriceStrategy === Constants.ALL ? (
                                                <Column
                                                    field='price.value'
                                                    header={t('employee.details.price')}
                                                    body={this.contractPriceTemplate.bind(this)}
                                                ></Column>
                                            ) : null
                                            }
                                            {canViewPrices ? (
                                                <Column
                                                    field='cost.value'
                                                    header={t('employee.details.cost')}
                                                    body={this.contractCostTemplate.bind(this)}
                                                ></Column>
                                            ) : null
                                            }
                                            {(this.state.viewMode !== 'VIEW' && canViewPrices) ? (
                                                <Column header='' body={this.contractsActionsTemplate.bind(this)}></Column>
                                            ) : null}
                                        </DataTable>
                                        {
                                            this.state.element.contracts.length !== 0 ?
                                                <div aria-live='assertive'>
                                                    {this.validator.message(
                                                        'contracts',
                                                        'Kontrakty',
                                                        this.state.element.contracts,
                                                        `contract_from_create_date_exists:${this.state.element.createDate}
                                                                    |contract_no_duplicates`
                                                    )}
                                                </div>
                                                :
                                                <div aria-live='assertive'>
                                                    {this.validator.message(
                                                        'contracts',
                                                        'Kontrakty',
                                                        this.state.element,
                                                        `contract_must_be_defined`
                                                    )}
                                                </div>
                                        }
                                    </DivContainer>
                                    <DivContainer>
                                        <ActionLink
                                            label={t('employee.details.addContractButton')}
                                            iconName='mdi-plus'
                                            iconSide='left'
                                            iconSize='icon-large'
                                            variant='blue'
                                            className='float-right'
                                            key={'add-activity-button'}
                                            handleClick={() => {
                                                const contracts = this.state.element.contracts;
                                                const maxDate = new Date(Math.max(...contracts.map((c) => c.dateFrom.getTime())));
                                                let newDateFrom = moment().toDate();
                                                if (maxDate && moment(maxDate).isSameOrAfter(moment(), this.contractDayMode.view)) {
                                                    newDateFrom = moment(maxDate).add(1, this.contractDayMode.view).toDate();
                                                }
                                                contracts.unshift({ dateFrom: newDateFrom, price: {}, cost: {} });

                                                this.setState(
                                                    (prevState) => ({
                                                        element: {
                                                            ...prevState.element,
                                                            contracts,
                                                        },
                                                    }),
                                                    () => this.setContractsDatesTo()
                                                );
                                            }}
                                            rendered={canViewPrices && this.canAddNewContract()}
                                        />
                                    </DivContainer>
                                </Card>
                            </div>
                        </TabPanel>

                        {this.props.viewMode !== 'NEW' ? (
                            <TabPanel header={t('project.details.logsTabHeader')}>
                                <LogEntryListContainer
                                    objectType='USER'
                                    objectId={this.props.elementId}
                                    expandFilters={false}
                                    renderHeader={false}
                                />
                            </TabPanel>
                        ) : null}
                    </TabView>
                </DivContainer>
                {this.state.showConfirmBlockDialog && this.state.element.status.enumValue === 'ACTIVE' ? (
                    <YesNoDialog
                        visible={this.state.showConfirmBlockDialog}
                        header={t('internaluser.details.dialogBlockHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.blockAccount();
                            } else {
                                this.hideBlockConfirmation();
                            }
                        }}
                        onHide={() => {
                            this.hideBlockConfirmation();
                        }}
                    >
                        {t('internaluser.details.dialogBlockQuestion')}
                    </YesNoDialog>
                ) : this.state.showConfirmUnblockDialog && this.state.element.status.enumValue !== 'ACTIVE' ? (
                    <YesNoDialog
                        visible={this.state.showConfirmUnblockDialog}
                        header={t('internaluser.details.dialogUnblockHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.unblockAccount();
                            } else {
                                this.hideUnblockConfirmation();
                            }
                        }}
                        onHide={() => {
                            this.hideUnblockConfirmation();
                        }}
                    >
                        {t('internaluser.details.dialogUnblockQuestion')}
                    </YesNoDialog>
                ) : null}
            </React.Fragment>
        );
    }

    handleCloseDialog(e, callback) {
        this.setState({dialogVisibile: false, element: undefined}, () => {
            if (callback) callback();
        });
    }

    handleGoToDetail(e, rowData, x) {
        if (e) {
            e.preventDefault();
        }
        this.setState({stepView: 'DETAILS', element: rowData});
    }
}
InternalUserContainer.defaultProps = {
    backUrl: '#/user-list',
    cancelUrl: '/#/user-list',
    editUrl: '/#/user/edit',
};

InternalUserContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};
export default withRouter(withTranslation()(InternalUserContainer));
